import Note from "./Note";
// Song.js -- example usage:
// var twink = new Song('Twinkle');   // create a song
// twink.rawNotes = ["C", "C", "G", "G", "A", "A", "G", "F", "F", "E", "E", "D", "D", "C`"];
// twink.lyrics = ["/4", "/4", "/4", "/4", "/4", "/4", "/2", "/4", "/4", "/4", "/4", "/4", "/4", "/2"];
// twink.adjustTimingAndLyrics(); // creates the formatted version of notes and lyrics with padding to align visually
// document.getElementById("output1").innerHTML = ('<pre>' + song2.formattedLyrics + '</pre>'); // write result into the page
// document.getElementById("output2").innerHTML = ('<pre>' + song2.formattedNotes + '</pre>');
//
class Song {
  constructor() {
    this.title = "Untitled";
    this.rawNotes = [];
    this.lyrics = [];
    this.currentPosition = 0; // for guidedPlay mode this is the next note to play
    this.tempo = 60; // beats per mlsPerMinute
    this.timeSignature = "4/4"; // default to 4/4
    this.notes = []; // the sequence of Note object instances that make up the song

    // TODO add key signature ["C", "G", "Eb"] Major x+2457911   3
    this.readFromCsvFile = this.readFromCsvFile.bind(this);
  }

  currentNote() {
    return this.notes[this.currentPosition];
  }

  advance() {
    let i = this.currentPosition++;
    // TODO end of song... what next?
    if (i === this.notes.length - 1) {
      i = this.currentPosition = 0;
    }
    return this.notes[i];
  }

  // calculate the milliseconds per beat based on the song tempo
  // duration in msec/beat = 60 sec/min * 1000 msec/sec / tempo beats/min
  getBeatDuration() {
    return 60 * 1000 / this.tempo; // milliseconds per beat--i.e. per quarter note in 4/4 time
  }

  // Get the note value per beat by assuming an integer after "/" in the time signature e.g. "5/8"
  getTimeSignatureDenominator() {
    return parseInt(this.timeSignature.split("/")[1], 10);
  }

  // play the notes of this song starting at 'position', respecting note pitch and duration
  play(position) {
    if (position < this.notes.length) {
      let note = this.notes[position];
      let duration = note.getDurationInMsec(
        this.getBeatDuration(),
        this.getTimeSignatureDenominator()
      );
      console.log(`playing ${note.raw} for ${duration} msec/`);
      note.play();
      setTimeout(() => this.play(position + 1), duration);
    }
  }

  readFromCsvFile(url, refreshFtn) {
    var thisSong = this;
    var path = url;
    function dirname(filepath) { return filepath.split('/').slice(0,-1).join('/'); }
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        thisSong.url = new URL(dirname(path), window.location.href);
        console.log('base url for song is: ' , thisSong.url);
        thisSong.parseCsv(responseText);
        thisSong.parseRawNotesAndLyrics();
        thisSong.currentPosition = 0; // start playing at the beginning
        return thisSong;
      })
      .then(refreshFtn)
      .catch(error => {
        console.log('error" ' + error);
      });
    console.log(`request for csv file "${url}" sent.`);
  }



  // Process a string that has the entire contents of a csv file and return a javascript Song object with all
  // information from the file saved as object properties. For instance this might be called with this string:
  //   "name,Twinkle,,,,,,\n"
  //   + "title,Twinkle Twinkle Little Star,,,,,,\n"
  //   + "tempo,60,,,,,,\n"
  //   + "notes,A/4,B/2,C/1,D/8,E/16,F/4,G/4\n"
  //   + "lyrics,My,dog,has,fleas,and,ticks,galore."
  // and it will return this object:
  //  {
  //    name: 'Twinkle',
  //    title: 'Twinkle Twinkle Little Star',
  //    tempo: 60,
  //    notes: ['A/4','B/2','C/1','D/8','E/16','F/4','G/4'],
  //    lyrics: ['My','dog','has','fleas','and','ticks','galore.']
  //  }
  parseCsv(csvString) {
    // console.log(csvString);
    let lines = csvString.split("\n");
    for (var i = 0; i < lines.length; i++) {
      var cols = lines[i].split(",");
      switch (cols[0]) {
        case "notes":
          this.rawNotes = cols.slice(1);
          break;
        case "lyrics":
          this.lyrics = cols.slice(1);
          break;
        case "tempo":
          this.tempo = parseInt(cols[1], 10);
          break;
        case "cover":
          let coverFileName = cols[1];
          const url = new URL(this.url.pathname + '/' + coverFileName, this.url);
          this.coverImageUrl = url.href;
          console.log('coverImage filepath: ', url.href);
          break;
        default:
          // effectively convert "a,something" into result.a = 'something'
          this[cols[0]] = cols[1];
      }
    }
    return this;
  }

  // Run through the rawNotes array creating a new Note instance for each one in the song.notes array.
  parseRawNotesAndLyrics() {
    this.notes = [];
    for (let i = 0; i < this.rawNotes.length; i++) {
      let note = new Note(this.rawNotes[i]);
      note.lyric = this.lyrics[i];
      this.notes.push(note);
    }
    return this;
  }
}
export default Song;



// WEBPACK FOOTER //
// ./src/Song.js